<template>
    <div class="row d-flex align-items-end mb-xl-3 mx-0 gap-2 flex-xl-nowrap">
        <!-- Voice -->
        <div class="col-xl-3 px-0 flex-shrink-1">
            <label
                class="whitespace-nowrap me-2 my-0"
                for="tts-voice"
            >
                Голос
            </label>

            <select
                id="tts-voice"
                v-model="params.voice"
                class="form-select my-0"
            >
                <option value="0">
                    გიორგი (Giorgi)
                </option>
                <option value="1">
                    ეკა (Eka)
                </option>
            </select>
        </div>

        <!-- Rate (speed) -->
        <div class="col-xl-3 px-0 flex-shrink-1">
            <label
                class="whitespace-nowrap me-2 my-0"
                for="tts-rate"
            >
                Скорость
            </label>
            <select
                id="tts-rate"
                v-model="params.rate"
                class="form-select my-0"
            >
                <option
                    v-for="rateOption in rateOptions"
                    :key="rateOption.value"
                    :value="rateOption.value"
                    v-html="rateOption.label"
                />
            </select>
            <!-- <range-slider -->
            <!--     id="tts-speed" -->
            <!--     class="slider" -->
            <!--     min="0" -->
            <!--     max="100" -->
            <!--     value="50" -->
            <!-- /> -->
        </div>

        <!-- Pitch -->
        <div class="col-xl-3 px-0 flex-shrink-1">
            <label
                class="whitespace-nowrap me-2 my-0"
                for="tts-pitch"
            >
                Тональность
            </label>
            <select
                id="tts-pitch"
                v-model="params.pitch"
                class="form-select my-0"
            >
                <option
                    v-for="pitchOption in pitchOptions"
                    :key="pitchOption.value"
                    :value="pitchOption.value"
                    v-html="pitchOption.label"
                />
            </select>
        </div>

        <!-- Volume -->
        <div class="col-xl-3 px-0 flex-shrink-1">
            <label
                class="whitespace-nowrap me-2 my-0"
                for="tts-volume"
            >
                Громкость
            </label>
            <select
                id="tts-volume"
                v-model="params.volume"
                class="form-select my-0"
            >
                <option
                    v-for="volumeOption in volumeOptions"
                    :key="volumeOption.value"
                    :value="volumeOption.value"
                    v-html="volumeOption.label"
                />
            </select>
        </div>

        <!-- Reset -->
        <div class="col-xl-auto px-0 flex-shrink-1">
            <!-- For desktops -->
            <button
                class="tts-reset-form desktop border-1 btn px-2 d-none d-xl-block"
                data-bs-toggle="tooltip"
                title="Сбросить всё"
                @click="resetForm()"
            >
                <i class="fa-solid fa-arrow-rotate-right"/>
            </button>
            <!-- For mobiles -->
            <button
                class="tts-reset-form mobile btn px-2 mt-1 mb-3 d-xl-none"
                @click="resetForm()"
            >
                <i class="fa-solid fa-arrow-rotate-right"/>
                <span class="d-xl-none ms-2">Сбросить всё</span>
            </button>
        </div>
    </div>

    <!-- Main form -->
    <form @submit.prevent="ttsMake()">
        <div class="position-relative">
            <textarea
                id="tts-textarea"
                v-model="params.text"
                :maxlength="inputMaxLength"
                class="form-control"
                rows="9"
                required
                placeholder="Введите текст или"
            />
            <a
                v-if="!params.text"
                class="use-example"
                href=""
                @click.prevent="useExample()"
            >
                сгенерируйте пример
            </a>
            <div
                :class="{'color-e13a3a': params.text.length === inputMaxLength}"
                class="textarea-info"
            >
                {{ params.text.length }}/{{ inputMaxLength }}
            </div>
        </div>
        <!-- Audio resource -->
        <div class="text-center mt-2">
            <audio
                id="tts-audio"
                :class="{'d-none': !voiceReady}"
                class="w-100"
                controls
            >
                <source
                    src=""
                    type="audio/mpeg"
                >
            </audio>
        </div>
        <!-- Language warning -->
        <p
            v-if="textContainsNonGeorgianLetters"
            :class="{'mt-3': !voiceReady}"
            class="alert alert-warning mb-2"
            role="alert"
        >
            <b>Обратите внимание</b>: озвучиваются только грузинские буквы.
        </p>
        <!-- Error -->
        <div
            v-if="errorMessage"
            class="alert alert-danger session-message mb-2"
        >
            <p
                class="mb-0"
                v-html="errorMessage"
            />
        </div>
        <!-- Submit data -->
        <div class="text-center pb-3 pb-xl-0">
            <button
                :class="{disabled: voiceLoading}"
                class="btn btn-danger position-relative mt-2 col-12 col-xl-auto"
                type="submit"
            >
                <span
                    v-if="voiceLoading"
                    class="spinner spinner-bigger position-absolute pointer-events-none"
                />
                Озвучить текст
            </button>
        </div>
    </form>
</template>

<script>
// import RangeSlider from '@components/RangeSlider.vue'

export default {
    name: 'TtsMain',
    components: {
        // RangeSlider
    },
    data() {
        return {
            voiceLoading: false,
            voiceReady: false,
            inputMaxLength: 1000,
            params: {
                text: '',
                voice: 0,
                pitch: 0,
                volume: 100,
                rate: 0,
            },
            rateOptions: [
                {label: '0.5', value: -50},
                {label: '0.75', value: -25},
                {label: 'Обычная', value: 0},
                {label: '1.25', value: 25},
                {label: '1.5', value: 50},
                {label: '1.75', value: 75},
                {label: '2', value: 100},
            ],
            pitchOptions: [
                {label: 'Очень низкая', value: -40},
                {label: 'Низкая', value: -20},
                {label: 'Средняя', value: 0},
                {label: 'Высокая', value: 20},
                {label: 'Очень высокая', value: 40},
            ],
            volumeOptions: [
                {label: '100%', value: 100},
                {label: '90%', value: 80},
                {label: '80%', value: 60},
                {label: '70%', value: 40},
                {label: '60%', value: 20},
                {label: '50%', value: 0},
                {label: '40%', value: -20},
                {label: '30%', value: -40},
                {label: '20%', value: -60},
                {label: '10%', value: -80},
            ],
            textContainsNonGeorgianLetters: false,
            bufferedParams: null,
            aphorisms: [
                'სამხედრო ძალაა - ხმალი და ფარი, ნასწავლის ძალა კი - ცოდნა და ენა', // ხალხური
                'სწავლა გონების საზრდოა და ჭკუის წარმატებაო', // ხალხური
                'მხოლოდ განათლება იყო და არის წყარო ყოველგვარი ხალხის ბედნიერებისა და კეთილდღეობისა', // აკაკი წერეთელი
                'მთავარი ძალა, რაც გამარჯვებას ანიჭებს ერს საარსებო ბრძოლაში, არის ცოდნა, განათლება', // იაკობ გოგებაშვილი
                'ენის შესწავლას ყოველთვის მოსდევს თვით ერის შეგნება და დაახლოვებაც', // ალექსანდრე ხახანაშვილი
                'ცოდნა, სწავლა-განათლება დღევანდელი კაცისთვის არსებითი პურია', // ილია ჭავჭავაძე
            ],
            textWriteTimeout: null,
            errorMessage: '',
            abortController: null,
        }
    },
    watch: {
        params: {
            handler(newVal) {
                this.textContainsNonGeorgianLetters = /[a-zа-яё]/imu.test(newVal.text)
            },
            deep: true
        }
    },
    created() {
        this.defaultParams = Object.assign({}, this.params)
    },
    mounted() {
        let $textarea = $('#tts-textarea')
        // Sync the text value in case of reopening closed tab
        setTimeout(() => this.params.text = $textarea.val(), 4)

        // Ctrl + Enter
        $textarea.on('keypress', (e) => {
            if (e.ctrlKey && (e.which === 13 || e.keyCode === 13)) {
                this.ttsMake()
            }
        })
    },
    methods: {
        // Make an mp3 file and run it
        ttsMake() {
            let audioElement = $('#tts-audio')[0]
            // Pause currently playing audio
            audioElement.pause()
            // Check if the same audio is ready already
            if (
                !this.errorMessage
                && (JSON.stringify(this.params) === JSON.stringify(this.bufferedParams))
                && this.voiceReady
            ) {
                // Reset the audio player settings
                audioElement.currentTime = 0
                audioElement.play()
                    .then(() => {
                        // Hide errors
                        this.errorMessage = ''
                    })
                    .catch(() => {
                        this.errorMessage = 'Не удалось запустить аудио автоматически. Возможно, ваш браузер блокирует автовоспроизведение.'
                    })
                // Show the audio player
                this.voiceReady = true
                // Hide the loading spinner
                this.voiceLoading = false
                return
            }
            // Hide the audio player
            this.voiceReady = false
            // Show the loading spinner
            this.voiceLoading = true
            // Hide errors
            this.errorMessage = ''
            // Stop auto writing into the textarea
            clearTimeout(this.textWriteTimeout)

            // Abort previous request if exists
            this.abortController?.abort()
            this.abortController = new AbortController()

            // If recaptcha has not been initialized, show an error and skip the request
            if (!grecaptcha) {
                // Show the error message
                this.errorMessage = 'Произошла ошибка. Пожалуйста, перезагрузите страницу и попробуйте снова.'
                // Hide the loading spinner
                this.voiceLoading = false
                return
            }
            grecaptcha.ready(() => {
                grecaptcha.execute('6Lcbo5MkAAAAAB8UQm-cCOn8oWoLMUoan1b5yN-u', {action: 'tts_make'})
                    .then((recaptchaToken) => {
                        // Save current parameters to the buffer
                        this.bufferedParams = Object.assign({}, this.params)
                        // Send an audio creation task to the server
                        axios.post(
                            '/api/tools/tts/make',
                            {
                                ...this.bufferedParams,
                                recaptchaToken
                            },
                            {
                                signal: this.abortController.signal
                            }
                        )
                            .then(response => {
                                // Set the received audio url
                                $('#tts-audio source').attr('src', response.data.audio)
                                let audioElement = $('#tts-audio')[0]
                                // Load the audio
                                audioElement.load()
                                // Turn it on automatically
                                audioElement.play().catch(() => {
                                    this.errorMessage = 'Не удалось запустить аудио автоматически. Возможно, ваш браузер блокирует автовоспроизведение.'
                                })
                                // Show the audio player
                                this.voiceReady = true
                                // Hide the loading spinner
                                this.voiceLoading = false
                            })
                            .catch(error => {
                                if (error.code !== 'ERR_CANCELED') {
                                    console.log(error)
                                    // Hide the audio player
                                    this.voiceReady = false
                                    // Show the error message
                                    this.errorMessage = error.response?.data.message
                                    // Hide the loading spinner
                                    this.voiceLoading = false
                                }
                            })
                    })
                    .catch((error) => {
                        console.log(error)
                        // Hide the loading spinner
                        this.voiceLoading = false
                    })
            })
        },

        // Choose an example from the array of aphorisms and write it in the textarea char by char
        useExample() {
            let aphorism = this.aphorisms.slice().shuffle()[0]
            let data = this
            function addLetter() {
                if (!data.params.text || aphorism.length > data.params.text.length) {
                    data.params.text += aphorism[data.params.text.length]
                    data.textWriteTimeout = setTimeout(addLetter, 10)
                }
            }
            addLetter()
        },

        // Reset all changes and remove the written text
        resetForm() {
            // Abort the current request if it's currently running
            this.abortController?.abort()
            let audioElement = $('#tts-audio')[0]
            // Reset the audio player settings
            audioElement.pause()
            audioElement.currentTime = 0
            // Hide the loading spinner
            this.voiceLoading = false
            // Hide the audio player
            this.voiceReady = false
            // Hide errors
            this.errorMessage = ''
            // Stop auto writing into the textarea
            clearTimeout(this.textWriteTimeout)
            // Set default parameters
            this.params = Object.assign({}, this.defaultParams)
        }
    }
}
</script>

<style scoped lang="scss">
.spinner.spinner-bigger {
    top: 7px;
    left: -37px;
    @media (width < 1200px) {
        top: unset;
        bottom: -36px;
        left: 50%;
        transform: translateX(-50%);
    }
}
#tts-textarea {
    min-height: 100px;
    max-height: 400px;
    padding-bottom: 25px;
    border-bottom: none;
    background: transparent;
    &::-webkit-resizer {
        background: linear-gradient(315deg,
            #aaa 13%,
            #f3f3f3 13% 23%,
            #aaa 23% 30%,
            #f3f3f3 30% 40%,
            #aaa 40% 47%,
            #f3f3f3 47% 100%) no-repeat;
        background-size: 90% 90%;
    }
    @media (width < 450px) {
        &::-webkit-resizer {
            width: 30px;
            height: 30px;
            background: linear-gradient(315deg, #aaa 0 55%, #f3f3f3 55% 100%) no-repeat;
        }
    }
}
.textarea-info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 21px);
    height: 24px;
    border: 1px solid #ced4da;
    border-radius: 0 0 0 0.25rem;
    border-top: 1px solid #dee2e7;
    border-right: none;
    background: #f3f3f3;
    color: #777;
    font-size: 13px;
    line-height: 20px;
    text-align: right;
    &::after {
        position: absolute;
        z-index: -1;
        top: -1px;
        right: -21px;
        display: block;
        width: 100%;
        height: 24px;
        border-radius: 0 0 0.25rem 0;
        border-top: 1px solid #dee2e7;
        border-bottom: 1px solid #ced4da;
        background: inherit;
        content: '';
    }
}
.tts-reset-form {
    display: flex;
    height: 38px;
    align-items: center;
    &.mobile {
        @media (width < 1200px) {
            width: 100%;
            border-color: #e7e7e7;
            background-color: #f8f9fa;
            color: #000;
        }
    }
}
.use-example {
    position: absolute;
    top: 0;
    left: 151px;
    padding-top: 7px;
    border-bottom: 1px solid rgb(26,115,232);
    color: rgb(26,115,232) !important;
    font-weight: normal;
    text-decoration: none;
    transition: none;
    @media (width < 376px) {
        top: 27px;
        left: 14px;
    }
    &:hover {
        border: none;
        text-decoration: none !important;
    }
}
</style>
